import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Jobs from "@/pages/Jobs";
import JobForm from "@/pages/JobForm";
import Warehouse from "@/pages/Warehouse";
import Finance from "@/pages/Finance";
import Employees from "@/pages/Employees";
import Attendance from "@/pages/Attendance";
import Vehicles from "@/pages/Vehicles";
import Customers from "@/pages/Customers";
import CustomerDetail from "@/pages/CustomerDetail";
import Invoices from "@/pages/Invoices";
import InternalDocs from "@/pages/InternalDocs";
import InvoiceForm from "@/pages/InvoiceForm";
import Statistics from "@/pages/Statistics";
import WorkCatalog from "@/pages/WorkCatalog";
import Settings from "@/pages/Settings";
import Reminders from "@/pages/Reminders";
import PaymentReturn from "@/pages/PaymentReturn";
import Planner from "@/pages/Planner";
import PrijateEFaktury from "@/pages/PrijateEFaktury";
import AdminPanel from "@/pages/AdminPanel";
import { Terms, Privacy } from "@/pages/LegalPages";
import TryLanding from "@/pages/TryLanding";
import CookieConsent from "@/components/CookieConsent";
import { captureAttribution, loadAnalytics } from "@/lib/analytics";

function App() {
  useEffect(() => {
    captureAttribution();
    loadAnalytics();
  }, []);
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/vyskusat" element={<TryLanding />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/payment/success" element={<PaymentReturn />} />
            <Route path="/payment/cancel" element={<PaymentReturn cancel />} />
            <Route path="/obchodne-podmienky" element={<Terms />} />
            <Route path="/ochrana-osobnych-udajov" element={<Privacy />} />
            <Route path="/dochadzka/:token" element={<Attendance />} />
            <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="zakazky" element={<Jobs />} />
              <Route path="zakazky/nova" element={<JobForm />} />
              <Route path="zakazky/:id/upravit" element={<JobForm />} />
              <Route path="sklad" element={<Warehouse />} />
              <Route path="financie" element={<Finance />} />
              <Route path="zamestnanci" element={<Employees />} />
              <Route path="vozidla" element={<Vehicles />} />
              <Route path="pripomienky" element={<Reminders />} />
              <Route path="planovac" element={<Planner />} />
              <Route path="zakaznici" element={<Customers />} />
              <Route path="zakaznici/:id" element={<CustomerDetail />} />
              <Route path="faktury" element={<Invoices />} />
              <Route path="interne-doklady" element={<InternalDocs />} />
              <Route path="faktury/nova" element={<InvoiceForm />} />
              <Route path="faktury/:id/upravit" element={<InvoiceForm />} />
              <Route path="prijate-efaktury" element={<PrijateEFaktury />} />
              <Route path="statistiky" element={<Statistics />} />
              <Route path="cennik-prac" element={<WorkCatalog />} />
              <Route path="nastavenia" element={<Settings />} />
              <Route path="admin" element={<AdminPanel />} />
            </Route>
          </Routes>
          <CookieConsent />
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
